import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Modal } from "@shared/components";
import { PlanFormProduct } from "./PlanFormProduct";
import { useParams } from "react-router";
import { ProductPlanFormValues } from "@modules/defaultProducts/types";
import { updateProductPlanService } from "@modules/defaultProducts/services/mutations/updateProductPlan";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";
import { masks } from "@core/utils/masks";

type EditProductPlanModalProps = {
  modalRef: React.Ref<any>;
  onSave: (data: any) => void;
};

export function EditProductPlanModal({
  modalRef,
  onSave,
}: EditProductPlanModalProps) {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { open } = useNotification();

  const methods = useForm<ProductPlanFormValues>({
    defaultValues: {
      id: undefined,
      name: "",
      value: "",
      description: "",
      default_product: id ? parseInt(id) : 0,
      level: 0,
      vindi_page: "",
      vindi_token: "",
    },
    mode: "onBlur",
  });

  const updatePlanMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<ProductPlanFormValues> }) =>
      updateProductPlanService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: "Plano atualizado com sucesso!",
      });
      queryClient.invalidateQueries({ queryKey: ["default_plan_admin"] });
      onSave({});
      (modalRef as React.MutableRefObject<any>).current?.close();
    },
    onError: (error) => {
      console.error("Erro ao atualizar plano:", error);
      open?.({
        type: "error",
        message: "Erro ao atualizar plano. Tente novamente.",
      });
    },
  });

  const handleConfirm = async () => {
    const values = methods.getValues();

    values.value = values.value ? String(Number(masks.unmask(values.value)) / 100) : '0'

    if (values?.id !== undefined) {
      updatePlanMutation.mutate({ id: values.id.toString(), data: values });
    }
  };

  return (
    <Modal
      ref={modalRef as any}
      title={"Editar Plano"}
      onConfirm={handleConfirm}
      methods={methods}
      isPending={updatePlanMutation.isPending}
    >
      <FormProvider {...methods}>
        <PlanFormProduct productId={!!id} />
      </FormProvider>
    </Modal>
  );
}
